import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

/**
 * Exibe consultas Serasa Relato (PJ) antigas, gravadas no formato legado (ReturnRelato)
 * antes da migração para a integração REST InfoMais. Mantido separado do RelatoComponent
 * (que atende exclusivamente o formato novo) para não alterar a integração REST atual.
 */
@Component({
  selector: 'app-relato-legado',
  templateUrl: './relato-legado.component.html',
  styleUrls: ['./relato-legado.component.scss']
})
export class RelatoLegadoComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  serasaObj;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
  }

  closeModal() {
    this.close();
  }

  sumTotais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].Valor) {
        total += obj[i].Valor;
      }
    }
    return total;
  }

  sumCapitais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].Capital) {
        total += obj[i].Capital;
      }
    }
    return total;
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/relato-legado/relato-legado.component.ts